module.exports = __webpack_public_path__ + "media/authors/shawna-newman-horizontal-449b4612.jpg";